import { isSignatureValue } from "../../../../../components/SignaturePad/signature-path.js";
//#region src/modules/FormBuilder/components/Fields/Signature/validate.ts
/**
* Validation for the `signature` field.
*
* The field stores whatever the signer actually entered — ink, a name, or both
* — rather than collapsing a partially filled field to `undefined`. That means
* the shared validator's plain truthiness check can't speak for this type: a
* name-only value is truthy but carries no signature. This function is the
* replacement, and it is the only place the two options are interpreted.
*
* - `required` governs the ink. A typed name is not a signature.
* - `requireName` governs the name, but only once something has been signed.
*   An untouched optional field stays valid, while a signature drawn without a
*   name is reported instead of being silently discarded.
*
* See `docs/FormBuilder-signature-field-contract.md` §2.
*/
function getSignatureFieldError(options, value) {
	const signature = isSignatureValue(value) ? value : void 0;
	const hasInk = !!signature?.d;
	const hasName = !!signature?.signerName?.trim();
	if (options.required && !hasInk) return "A signature is required";
	if (options.requireName && hasInk && !hasName) return "Signer name is required";
}
//#endregion
export { getSignatureFieldError };

//# sourceMappingURL=validate.js.map